import { useEffect } from 'react';
import './Legend.scss';
import { LegendAccordion } from './LegendAccordion';
import { useStoreContext } from 'src/store/context';

export const CustomLegend: React.FC=()=>{ 
  const [state] = useStoreContext();
  useEffect(() => {
  }, [state.alerts]);
  return(
	<div data-testid={'legend-container'}>
    {
      <div className={state.alerts?.filter((a)=>a.type==='warning')?.length>0?"legend-container-deploy-banner":"legend-container"} id="legend-container" data-testid={'legend-container-open'}>
        <LegendAccordion/>
      </div>
    }
	</div>
  )
}

export default CustomLegend;